<div id="layout-wrapper">
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <div class="navbar-brand-box">
          <a href="/" class="logo">
            <span class="logo-box cus-logo-box">
              <img
                [ngClass]="{ move: !isCondensed }"
                src="assets/imgs/logo.png"
                alt=""
                *ngIf="!isCondensed"
              />
              <img
                [ngClass]="{ small: isCondensed }"
                src="assets/imgs/logo.png"
                alt=""
                *ngIf="isCondensed"
              />
            </span>
          </a>
        </div>

        <button
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          id="vertical-menu-btn"
          (click)="toggleMobileMenu($event)"
          (settingsButtonClicked)="onSettingsButtonClicked()"
          (mobileMenuButtonClicked)="onToggleMobileMenu()"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>
      </div>

      <div class="d-flex">
        <button
          class="btn header-item font-size-14 d-flex align-items-center"
          (click)="logout()"
        >
          <i class="bx bx-log-out mr-1"></i>
          로그아웃
        </button>
      </div>
    </div>
  </header>

  <ng-template #contentTemplate>
    <!--- Sidemenu -->
    <div id="sidebar-menu">
      <!-- Left Menu Start -->

      <!--메인메뉴-->
      <ul class="metismenu list-unstyled" *ngIf="menu">
        <li *ngFor="let list of menu; let menuIndex = index">
          <!--서브메뉴 없을때-->
          <a
            *ngIf="!list.subItems || list.subItems?.length == 0"
            routerLink="{{ list.link }}"
            routerLinkActive="active"
            #aTag
            (click)="close(aTag)"
          >
            <i class="bx {{ list.icon ? list.icon : '' }}"></i>
            <span>{{ list.label }}</span></a
          >
          <!--서브메뉴 있을때-->
          <a
            *ngIf="list.subItems && list.subItems?.length > 0"
            class="has-arrow"
            href="javascript: void(0);"
            (click)="open(list, menu, menuIndex)"
            [ngClass]="{ 'up-arrow': list.openSwitch }"
          >
            <i class="bx {{ list.icon ? list.icon : '' }}"></i>
            <span>{{ list.label }}</span>
            <span *ngIf="list.alarmSwitch" class="badge-alarm"></span
          ></a>
          <!--서브메뉴 리스트-->
          <ul
            class="sub-menu"
            aria-expanded="true"
            [ngClass]="{ 'side-close': !list.openSwitch }"
          >
            <li *ngFor="let item of list.subItems; let i = index">
              <a
                class="side-nav-link-ref, atag{{ menuIndex }}{{ i }}"
                [routerLink]="item.link"
                routerLinkActive="active"
              >
                <span>{{ item.label }}</span>
                <span *ngIf="item.alarmSwitch" class="badge-alarm"></span
              ></a>
            </li>
          </ul>
        </li>

        <!-- end Layout menu -->

        <!-- </ng-container> -->
      </ul>
    </div>
  </ng-template>
  <!-- Sidebar -->

  <div class="vertical-menu">
    <perfect-scrollbar [config]="configData">
      <div *ngIf="!isCondensed">
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </div>
      <div *ngIf="isCondensed">
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </div>
    </perfect-scrollbar>
  </div>

  <div class="main-content">
    <div class="page-content">
      <!-- content -->
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
